import React from 'react';
import styles from './Steps.module.scss';

/* Components */
import { StepButton } from './StepButton';

interface StepsProps {
  onSelectStep: (i: number) => void;
  checkStepValidity: (stepNumber: number) => boolean;
  selectedStep: IStep;
  steps: IStep[];
}

export type IStep = 'TIP' | 'DETAIL' | 'PRICE' | 'PUBLISH';

export const allSteps: IStep[] = ['TIP', 'DETAIL', 'PRICE', 'PUBLISH'];

export const Steps: React.FC<StepsProps> = ({
  onSelectStep,
  checkStepValidity,
  selectedStep,
  steps,
}) => {
  return (
    <div className={styles.Steps}>
      <div className={styles.stepsBtns}>
        {steps.map((step: IStep, index: number) => (
          <StepButton
            tag={step}
            selected={selectedStep === step}
            steps={steps}
            stepNum={index}
            onSelect={onSelectStep}
            checkStepValidity={() => checkStepValidity(allSteps.indexOf(step))}
            selectedStep={selectedStep}
            key={step}
          />
        ))}
      </div>
    </div>
  );
};
